export type environment = 'DEV' | 'EVAL' | 'PROD';
export type domain = 'fluentsms' | 'titlesolutions';

export const DEV = 'DEV';
export const TEST = 'TEST';
export const EVAL = 'EVAL';
export const PROD = 'PROD';
export const FLUENTSMS = 'fluentsms';
export const TITLESOLUTIONS = 'titlesolutions';

export const environments: {
  [url: string]: environment;
} = {
  'dev.fluent.titlesolutions.com': DEV,
  'eval.fluent.titlesolutions.com': EVAL,
  'fluent.titlesolutions.com': PROD,
  'dev.app.fluentsms.com': DEV,
  'app.fluentsms.com': PROD,
};

export const domains: {
  [url: string]: domain;
} = {
  titlesolutions: TITLESOLUTIONS,
  fluentsms: FLUENTSMS,
};

export const launchDarklyClientSideId: {
  [environment: string]: string;
} = {
  DEV: '6716d6e0350a37082f5ed7a4',
  EVAL: '6718c8647fbb2f086c9aded6',
  PROD: '6716d6e0350a37082f5ed7a5',
};

export const resolveDomain = (): domain => {
  const apiHostname = typeof window !== 'undefined' ? window?.location?.host : '';
  const hostnameArr = apiHostname.split('.');
  return domains[hostnameArr[hostnameArr.length - 2]] || TITLESOLUTIONS;
};

/**
 * Returns the current environment name based on the webpage's host.
 *
 * @returns {environment} env - the environment name.
 * @default DEV
 */
export const resolveEnv = (): environment => {
  const apiHostname = typeof window !== 'undefined' ? window?.location?.host : '';
  return environments[apiHostname] || DEV;
};

/**
 * Environments where developer-oriented diagnostics should be suppressed.
 *
 * Deliberately an allow-list rather than a deny-list
 *
 * @param {environment} [env] - environment to test; defaults to the resolved environment.
 * @returns {boolean} true for EVAL and PROD, false otherwise.
 */
export const isUpperEnvironment = (env: environment = resolveEnv()): boolean => env === EVAL || env === PROD;
